"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoursesDb = void 0;
const isomorphic_unfetch_1 = __importDefault(require("isomorphic-unfetch"));
const course_model_1 = require("./course.model");
const assets_1 = require("../helpers/assets");
class CourseDb {
    static addCourseSession(session) {
        var _a;
        if (!CourseDb.coursesDb[session.getSlug()]) {
            const course = new course_model_1.CourseModel();
            CourseDb.coursesDb[session.getSlug()] = course;
        }
        (_a = CourseDb.coursesDb[session.getSlug()]) === null || _a === void 0 ? void 0 : _a.addSession(session);
    }
    static getCourse(slug) {
        if (!CourseDb.coursesDb[slug]) {
            return null;
        }
        const course = CourseDb.coursesDb[slug];
        return course === undefined || course == null ? null : new course_model_1.CourseModel(course);
    }
    static async loadDb(fetcher = null, dbUrl = CourseDb.DEFAULT_PROD_DB_URL + "?r=" + Math.floor(Math.random() * 100000000), force = false, assetsConfig = null) {
        CourseDb.assetsConfig = assetsConfig;
        if (force || Object.keys(CourseDb.coursesDb).length <= 0) {
            CourseDb.coursesDb = {};
            CourseDb.coursesCodeMap = {};
            await CourseDb.fetchData(fetcher, dbUrl);
        }
        return CourseDb.getDbSynch();
    }
    static getDbSynch() {
        const localCoursesDb = {};
        for (let slug of Object.keys(CoursesDb.coursesDb)) {
            const course = CoursesDb.getCourse(slug);
            if (course != null) {
                localCoursesDb[slug] = course;
            }
        }
        return localCoursesDb;
    }
    static importDb(courseDbMapSerialized) {
        const serializedCourses = JSON.parse(courseDbMapSerialized);
        for (const courseSerialized of Array.from(Object.values(serializedCourses))) {
            if (!courseSerialized || courseSerialized === null) {
                continue;
            }
            else {
                const course = (0, assets_1.configureCourseAssets)(course_model_1.CourseModel.fromJSON(courseSerialized), CourseDb.assetsConfig);
                CoursesDb.coursesDb[course.slug] = course;
                for (let sessionId of Object.keys(course.sessions)) {
                    if (typeof sessionId === 'string') {
                        let productCode = CoursesDb.coursesDb[course.slug].sessions[sessionId].productCode;
                        CoursesDb.coursesCodeMap[productCode] = course.slug;
                    }
                }
            }
        }
    }
    static exportDb() {
        return JSON.stringify(CourseDb.coursesDb);
    }
    static async fetchData(fetcher = null, dbUrl) {
        CourseDb.coursesDb = {};
        CoursesDb.coursesCodeMap = {};
        const fetch = fetcher ? fetcher : isomorphic_unfetch_1.default;
        await fetch(dbUrl)
            .then((r) => r.text())
            .then((courseDbSerialized) => {
            CoursesDb.importDb(courseDbSerialized);
        });
        return CourseDb.coursesDb;
    }
    static size() {
        return Object.keys(CoursesDb.coursesDb).length;
    }
    static getCourseByProductCode(productCode) {
        if (CoursesDb.coursesCodeMap[productCode]) {
            const course = CoursesDb.coursesDb[CoursesDb.coursesCodeMap[productCode]];
            for (let sessionId of Object.keys(course.sessions)) {
                if (typeof sessionId === 'string' && course.sessions[sessionId] && course.sessions[sessionId].productCode && course.sessions[sessionId].productCode === productCode) {
                    const foundCourse = new course_model_1.CourseModel();
                    foundCourse.addSession(course.sessions[sessionId]);
                    return foundCourse;
                }
            }
        }
        return null;
    }
}
CourseDb.DEFAULT_PROD_DB_URL = "https://prod-datalayer-24orebs-storage.s3.eu-central-1.amazonaws.com/websitedata/courses/published_courses_db.json";
CourseDb.coursesCodeMap = {};
CourseDb.coursesDb = {};
CourseDb.assetsConfig = null;
const CoursesDb = CourseDb;
exports.CoursesDb = CoursesDb;
//# sourceMappingURL=coursedb.js.map